import { Injectable } from '@angular/core';
import { PaymentIntent } from '@stripe/stripe-js';
import { NumericDictionary } from 'cypress/types/lodash';
import { CallService } from '../../core/call-service/browser/call.service';
import { LogService } from '../../core/log/log.service';
import {
	checkPremiumTokenUrl,
	confirmCardPaymentUrl,
	createCouponUrl,
	getDiscountTypeUrl,
	getMyPremiumUrl,
	getPremiumModulesUrl,
	intentSubscriptionUrl,
	setSubscriptionUrl,
	updateSubscription
} from '../../core/router/routes-provider';
import {
	CompletePaymentIntent,
	CouponState,
	MyPremiumModuleElement,
	MyPremiumState,
	PaymentConfirmation,
	PremiumDiscountType,
	PremiumModuleElement,
	PremiumModules,
	PremiumSubscription
} from './extra.model';

@Injectable({
	providedIn: 'root'
})
export class ExtraService {
	constructor(private callService: CallService, private logService: LogService) {}

	loadPremiumModules(userId: number, forcedCampaigns: string) {
		const urltoCall = getPremiumModulesUrl(userId, forcedCampaigns);
		this.logService.info('Calling ', urltoCall);
		const result = this.callService.CallApi<PremiumModuleElement[]>('GET', urltoCall);
		return result;
	}

	loadUserPremium(userId: number) {
		const urltoCall = getMyPremiumUrl(userId);
		this.logService.info('Calling ', urltoCall);
		const result = this.callService.CallApi<MyPremiumState>('GET', urltoCall);
		return result;
	}

	loadDiscountType() {
		const urltoCall = getDiscountTypeUrl();
		this.logService.info('Calling ', urltoCall);
		const result = this.callService.CallApi<PremiumDiscountType[]>('GET', urltoCall);
		return result;
	}

	checkCodiceSconto(token: string, userId: number) {
		const urltoCall = checkPremiumTokenUrl(token, userId);
		this.logService.info('Calling ', urltoCall);
		const result = this.callService.CallApi<PremiumModules>('GET', urltoCall);
		return result;
	}

	createCoupon(idTipoSconto: number, userId: number) {
		const urltoCall = createCouponUrl(idTipoSconto, userId);
		this.logService.info('Calling ', urltoCall);
		const result = this.callService.CallApi<CouponState>('GET', urltoCall);
		return result;
	}

	updateSubscription( updateObject : {module: MyPremiumModuleElement, stripeId:string,  userId: number}) {
		const urltoCall = updateSubscription(
			updateObject.module.moduleId,
      // questo flag indica che stiamo procedendo con una disdetta. Ovvero il Rinnovo non deve essere automatico
      // se ci sarà poi la possibilità di gestire aggiornamenti di abbonamento diversi dalla disdetta, andrà gestito
			0,
			updateObject.module.discountTypeId,
			updateObject.module.subscriptionId,
      updateObject.stripeId,
      updateObject.userId
		);
		this.logService.info('Calling ', urltoCall);
		const result = this.callService.CallApi<boolean>('GET', urltoCall);
		return result;
	}

	setSubscription(subscription: PremiumSubscription) {
		const urlToCall = setSubscriptionUrl();

		const formData: any = new FormData();

		// formData.append('tokenId', subscription.tokenId);
		formData.append('totaleCoupon', subscription.totaleCoupon);
		formData.append('tokenCodice', subscription.tokenCodice);
		formData.append('listaIdModulo', subscription.listaIdModulo);
		formData.append('listaIdTipoSconto', subscription.listaIdTipoSconto);
		formData.append('listaIdTipoAbbonamento', subscription.listaIdTipoAbbonamento);
		formData.append('piva', subscription.piva);
		formData.append('pec', subscription.pec);
		formData.append('sd', subscription.sd);
		formData.append('idAnagrafica', subscription.idAnagrafica);
		formData.append('nome', subscription.nome);
		formData.append('cognome', subscription.cognome);
		formData.append('email', subscription.email);
    formData.append('sessionId', subscription.sessionId);


		this.logService.info('Calling ', urlToCall);
		const result = this.callService.CallApi<boolean>('POST', urlToCall, formData);
		return result;
	}

	intentSubscriptionAction(subscription: PremiumSubscription) {
		const urlToCall = intentSubscriptionUrl();

		const formData: any = new FormData();
		formData.append('totaleCoupon', subscription.totaleCoupon);
		formData.append('tokenCodice', subscription.tokenCodice);
		formData.append('listaIdModulo', subscription.listaIdModulo);
		formData.append('listaIdTipoSconto', subscription.listaIdTipoSconto);
		formData.append('listaIdTipoAbbonamento', subscription.listaIdTipoAbbonamento);
    formData.append('listaProdotti', subscription.listaProdotti);
		formData.append('piva', subscription.piva);
		formData.append('pec', subscription.pec);
		formData.append('sd', subscription.sd);
		formData.append('idAnagrafica', subscription.idAnagrafica);
		formData.append('nome', subscription.nome);
		formData.append('cognome', subscription.cognome);
		formData.append('email', subscription.email);
		formData.append('stripeId', subscription.stripeId);
		formData.append('sessionId', subscription.sessionId);

		this.logService.info('Calling ', urlToCall);
		const result = this.callService.CallApi<CompletePaymentIntent>('POST', urlToCall, formData);
		return result;
	}

	confirmCardPaymentAction(confirmation: PaymentConfirmation) {
		const urlToCall = confirmCardPaymentUrl();

		const formData: any = new FormData();
    formData.append('paymentStatus', confirmation.status);
		formData.append('card', confirmation.card?.id); // la carta potrebbe non essere presente. Nel caso di conferma di require action viaggia solo il payment intent (es. 3D)
		formData.append('clientSecret', confirmation.clientSecret);
		formData.append('paymentIntent', confirmation.paymentIntent);
		formData.append('stripeId', confirmation.stripeId);
		formData.append('fullname', confirmation.fullname);
		formData.append('idAnagrafica', confirmation.idAnagrafica);

		this.logService.info('Calling ', urlToCall);
		const result = this.callService.CallApi<CompletePaymentIntent>('POST', urlToCall, formData);
		return result;
	}
}
